import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../constants/colors';
import styled from 'styled-components';

const Root = styled.div`
  color: ${colors.theWhiteAlbum};
  & .expanded {
    margin: 0;
  }
`;

function SimpleExpansionPanel(props) {
  const { classes, children } = props;
  return <Root classes={classes}>{children}</Root>;
}

SimpleExpansionPanel.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

export default SimpleExpansionPanel;
